import {
  getVisitaCardStatus,
  getVisitaStatusClass,
  getVisitaStatusLabel,
  VISITA_CARD_STATUS,
  VISITA_CARD_STATUS_CLASSES,
  VISITA_CARD_STATUS_LABELS,
} from 'dashboard/helper/lais/visitaPresenter';
import { buildWhatsappLink, googleMapsLink } from 'shared/helpers/mapLinks';
import { entryAccessLabel, visitIntentionLabel } from './visitFlowCopy';

export const VISIT_DETAIL_SECTION_TITLES = Object.freeze({
  STATUS: 'Status da visita',
  VISIT: 'Informações da visita',
  HOUSE: 'Imóvel',
  RESPONSIBLE: 'Responsável pelo imóvel',
  VISITOR: 'Visitante',
  ENTRY: 'Entrada e chaves',
  HISTORY: 'Histórico de informações de entrada das últimas visitas',
  EXTRA_VISITS: 'Use seus horários disponíveis',
  OFFER: 'Proposta e negociação',
  HOUSE_DETAILS: 'Informações do imóvel',
  CIQ: 'Consultor Imobiliário',
  OWNER: 'Proprietário',
  PROPERTY_RESPONSIBLE: 'Responsável pelo imóvel',
  RESERVATION: 'Ofereça ao interessado',
  RENT_PROGRESS: 'Interesse no imóvel nos últimos 30 dias:',
  BRIEFING: 'Prepare-se para a visita',
  DIRECTIONS: 'Ver como chegar',
});

export const VISIT_DETAIL_TEXT = Object.freeze({
  PAGE_TITLE: 'Detalhes da visita',
  LOADING: 'Carregando detalhes da visita...',
  LOAD_ERROR_TITLE: 'Não foi possível carregar esta visita',
  LOAD_ERROR_DESCRIPTION:
    'Atualize a página ou volte para a agenda para tentar novamente.',
  BACK_TO_AGENDA: 'Voltar para agenda',
  SEND_PRESENTATION: 'Enviar apresentação',
  SEND_OFFER_LINK: 'Enviar link de proposta',
  ADD_MORE_VISITS: 'Adicionar mais visitas',
  FINISH_VISIT: 'Finalizar visita',
  RESCHEDULE_VISIT: 'Reagendar visita',
  CANCEL_VISIT: 'Cancelar visita',
  CONFIRM_VISIT: 'Confirmar visita',
  OPEN_VISITOR_PROFILE: 'Ver perfil do visitante',
  TALK_TO_OWNER: 'Conversar com proprietário',
  TALK_TO_VISITOR: 'Falar com visitante',
  TALK_TO_TENANT: 'Conversar com o inquilino',
  CALL_TENANT: 'Ligar para {tenantName}',
  WHATSAPP_TENANT: 'Conversar no WhatsApp',
  TENANT_CONTINUE_RESCHEDULE: 'Continuar para o reagendamento',
  TENANT_DIALOG_TITLE: 'Conversar com o inquilino',
  TENANT_DIALOG_DESCRIPTION:
    'Confira nossas dicas para uma boa experiência de visitas em imóveis alugados e ainda ocupados pelos atuais inquilinos.',
  TENANT_DIALOG_FIRST_TIP_TITLE: 'Se apresente e seja cordial',
  TENANT_DIALOG_FIRST_TIP:
    'O inquilino atual está passando por um processo de mudança. Logo, seja objetivo e eficiente durante a conversa.',
  TENANT_DIALOG_SECOND_TIP_TITLE: 'Faça o possível para realizar a visita',
  TENANT_DIALOG_SECOND_TIP:
    'Se o horário solicitado não for viável para o inquilino atual, busque outras opções e reagende a visita.',
  TENANT_BEST_PRACTICES_TITLE: 'Boas práticas de visita',
  TENANT_BEST_PRACTICES_BUTTON: 'Conheça nossas boas práticas de visita',
  TENANT_BEST_PRACTICES_DESCRIPTION:
    'Confira nossas dicas para uma boa experiência de visitas em imóveis alugados com inquilino morando.',
  TENANT_BEST_PRACTICES_ARRIVAL_TITLE: 'Avise só quando o visitante chegar',
  TENANT_BEST_PRACTICES_ARRIVAL:
    'Caso chegue mais cedo, avise a portaria e só comunique os moradores no momento em que estiver subindo com o visitante.',
  TENANT_BEST_PRACTICES_INVESTOR_TITLE: 'Informe se forem investidores',
  TENANT_BEST_PRACTICES_INVESTOR:
    'Alguns inquilinos podem ficar mais confortáveis ao saber dessa informação. Portanto, sempre comunique caso o motivo da compra seja investimento.',
  RESCHEDULE_WITH_TENANT: 'Reagendar visita',
  RESCHEDULE_WITH_TENANT_TITLE: 'Reagendar visita',
  RESCHEDULE_WITH_TENANT_DESCRIPTION:
    'Antes de seguir para o reagendamento, combine com o inquilino o melhor dia e horário para realizar esta visita.',
  STATUS_REQUESTED_TITLE: 'Aguardando confirmação',
  STATUS_REQUESTED_DESCRIPTION:
    'Combine os detalhes com o proprietário e informe se a visita pode acontecer até {date} às {time}.',
  STATUS_REQUESTED_TENANT_DESCRIPTION:
    'Antes de confirmar, fale com o inquilino atual para combinar entrada, data e horário da visita.',
  STATUS_CONFIRMED_TITLE: 'Visita confirmada',
  STATUS_CONFIRMED_DESCRIPTION:
    'A visita foi confirmada. A informação de entrada está atualizada e sua entrada está autorizada.',
  STATUS_CONFIRMED_TENANT_DESCRIPTION:
    'O imóvel está ocupado. Confira as boas práticas antes de subir com o visitante.',
  STATUS_SCHEDULED_TITLE: 'Visita agendada',
  STATUS_SCHEDULED_DESCRIPTION:
    'Envie a apresentação para alinhar endereço, horário e chegada com o visitante.',
  STATUS_CANCELED_TITLE: 'Visita cancelada',
  STATUS_CANCELED_DESCRIPTION: 'A visita foi cancelada.',
  STATUS_UNAVAILABLE_TITLE: 'Horário indisponível',
  STATUS_UNAVAILABLE_DESCRIPTION:
    'O proprietário não está disponível para visita nesse horário, mas ainda tem interesse em receber a visita.',
  STATUS_UNAVAILABLE_TENANT_DESCRIPTION:
    'O inquilino deste imóvel não pode receber visitas no horário sugerido pelo interessado. Entre em contato para negociar outra data.',
  STATUS_NOW_TITLE: 'Visita agora',
  STATUS_NOW_DESCRIPTION:
    'Consulte as características e valores de condomínio desse imóvel.',
  STATUS_PENDING_TITLE: 'Finalização pendente',
  STATUS_PENDING_DESCRIPTION: 'Você precisa finalizar esta visita.',
  STATUS_DONE_TITLE: 'Visita realizada',
  STATUS_DONE_DESCRIPTION:
    'Seu cliente gostou do imóvel? Sugira o envio de uma proposta.',
  STATUS_UNSUCCESSFUL_TITLE: 'Visita não realizada',
  STATUS_UNSUCCESSFUL_DESCRIPTION: 'A visita não foi realizada.',
  STATUS_NOT_HAPPENED_DESCRIPTION: 'Essa visita não foi realizada.',
  EXTRA_VISITS: 'Use seus horários disponíveis',
  EXTRA_VISITS_SUBTITLE:
    'Visite imóveis a menos de 800m e com o perfil do seu cliente',
  EXTRA_VISITS_EMPTY_TAG: 'Mais chance de fechar negócio',
  EXTRA_VISITS_EMPTY_TITLE:
    'Clientes com 3+ visitas têm o dobro de chance de fechar contrato',
  EXTRA_VISITS_EMPTY_SUBTITLE:
    'Otimize seu tempo e adicione novas visitas com perfil do seu cliente.',
  EXTRA_VISITS_EMPTY_BUTTON: 'Conferir perfil',
  EXTRA_VISITS_CONFIRM_TITLE: 'Revise e confirme o agendamento',
  EXTRA_VISITS_CONFIRM_DESCRIPTION:
    'Ao confirmar, as novas visitas vão ser agendadas.',
  EXTRA_VISITS_CONFIRM_BUTTON: 'Confirmar agendamento',
  EXTRA_VISITS_SUCCESS: 'Agendamento realizado!',
  EXTRA_VISITS_ERROR: 'Erro ao confirmar o agendamento. Tente novamente.',
  REQUEST_FEEDBACK_TITLE: 'Sua visita foi solicitada',
  REQUEST_FEEDBACK_DESCRIPTION:
    'A Secretaria de Vendas vai entrar em contato para te passar os detalhes dessa visita. Sugerimos que você aguarde esse contato antes de confirmar a visita com o seu cliente.',
  REQUEST_FEEDBACK_DETAIL_TITLE: 'Detalhes da visita solicitada',
  CIQ_DESCRIPTION:
    'Consultor representante do proprietário disponível para dúvidas sobre o imóvel.',
  CIQ_WHATSAPP_LABEL: 'Falar com o consultor do imóvel',
  OWNER_WITH_NO_PHONE: 'O proprietário não possui telefone',
  PROPERTY_RESPONSIBLE_PARTNER: 'Imobiliária parceira',
  TALK_TO_SECRETARY: 'Falar com a equipe do {companyName}',
  TALK_TO_OWNER_HELP: 'Precisa falar com o proprietário?',
  RESERVATION_TITLE: 'Reserva',
  RESERVATION_DESCRIPTION:
    'Aumenta as chances de alugar o imóvel, pois evita a concorrência de outros interessados.',
  RESERVATION_NOT_ALLOWED:
    'O proprietário desativou a opção de reserva para esse imóvel.',
  RESERVATION_HOW_IT_WORKS: 'Veja como funciona',
  RENT_PROGRESS_OFFERS_ZERO: 'Propostas enviadas',
  RENT_PROGRESS_OFFER_ONE: 'Proposta enviada',
  RENT_PROGRESS_OFFERS_MANY: 'Propostas enviadas',
  RENT_PROGRESS_DOCUMENTATION_ZERO: 'Documentações',
  RENT_PROGRESS_DOCUMENTATION_ONE: 'Documentação',
  RENT_PROGRESS_DOCUMENTATION_MANY: 'Documentações',
  RENT_PROGRESS_VISIT_ZERO: 'Visitas feitas + agendadas',
  RENT_PROGRESS_VISIT_ONE: 'Visita feita ou agendada',
  RENT_PROGRESS_VISIT_MANY: 'Visitas feitas + agendadas',
  BRIEFING_DESCRIPTION:
    'Entenda a temperatura do imóvel e como ele atende {clientName}.',
  BRIEFING_BUTTON: 'Preparar para visita',
  GOOGLE_MAPS: 'Google Maps',
  WAZE: 'Waze',
  CARD_HOUSE_ID_LABEL: 'Cód. Imóvel {houseId}',
  CARD_PUBLISH_DATE: 'Publicação: {publishDate}',
  EXCLUSIVE_TAG_LABEL: 'Exclusivo',
  COPY_HOUSE_ID: 'Copiar código do imóvel',
  GO_TO_LISTING_BUTTON: 'Ver anúncio',
  CODE_COPIED: 'Código copiado',
  CUSTOM_OFFER_TITLE: 'Negociação do valor do aluguel',
  CUSTOM_OFFER_ALLOWED_SUBTITLE:
    'O proprietário desse imóvel aceita negociar o valor do aluguel.',
  CUSTOM_OFFER_NOT_ALLOWED_SUBTITLE:
    'O proprietário desse imóvel não aceita negociar o valor do aluguel.',
  ENTRY_AVAILABILITY_TITLE: 'Disponibilidade para entrada',
  AVAILABILITY_IMMEDIATE:
    'Este imóvel está disponível para entrada imediata em até 6 dias úteis após o envio do contrato.',
  AVAILABILITY_EXACT:
    'Este imóvel está disponível para entrada a partir de {movingDate}.',
  AVAILABILITY_EXACT_WITH_REASON:
    'Este imóvel está disponível para entrada a partir de {movingDate}. Motivo: {reason}',
  AVAILABILITY_FLEXIBLE:
    'Este imóvel está disponível para entrada após {daysToVacate} dias da assinatura do contrato.',
  AVAILABILITY_FLEXIBLE_WITH_REASON:
    'Este imóvel está disponível para entrada após {daysToVacate} dias da assinatura do contrato. Motivo: {reason}',
  INCOME_PROOF_TITLE: 'Comprovação de renda',
  INCOME_PROOF_SUBTITLE:
    'Para alugar este imóvel é necessário comprovar renda mensal bruta de aproximadamente {income}',
  THIRD_PARTY_OWNERSHIP_TITLE_RENT: 'Administrado por imobiliária parceira',
  THIRD_PARTY_OWNERSHIP_TITLE_SALE: 'Imóvel de imobiliária parceira',
  THIRD_PARTY_OWNERSHIP_SUBTITLE_RENT:
    'Este imóvel é anunciado e administrado por uma imobiliária parceira do {companyName}. Com essa parceria, temos ainda mais opções de imóveis para você e seus clientes.',
  THIRD_PARTY_OWNERSHIP_SUBTITLE_SALE:
    'Imóveis anunciados pelas imobiliárias parceiras do {companyName}. Ainda mais opções de imóveis para você e seus clientes com os mesmos benefícios que o {companyName} oferece.',
  THIRD_PARTY_OWNERSHIP_DIALOG_TITLE:
    'Quais são os diferenciais desses imóveis?',
  MANAGED_BY_OWNER_TITLE: 'O Aluguel é direto com o proprietário',
  MANAGED_BY_OWNER_DESCRIPTION:
    'O {companyName} cuida de todo o processo até a vistoria de entrada. Depois disso, o proprietário cuida de tudo referente ao aluguel.',
  MANAGED_BY_OWNER_BUTTON: 'Saiba mais sobre este modelo',
  MANAGED_BY_OWNER_MODAL_TITLE: 'Este imóvel é administrado pelo proprietário',
  MANAGED_BY_OWNER_MODAL_DESCRIPTION:
    'Isso quer dizer que o {companyName} cuida de todo o processo até você receber a vistoria de entrada. Depois, o proprietário cuida de tudo referente ao seu aluguel, como receber pagamentos e pedidos de reparo.',
  MANAGED_BY_OWNER_MODAL_BUTTON: 'Ok, entendi',
});

export const VISIT_DETAIL_STATUS_ACTIONS = Object.freeze({
  CONFIRM_VISIT: 'confirm_visit',
  FINISH_VISIT: 'finish_visit',
  RESCHEDULE_VISIT: 'reschedule_visit',
  CANCEL_VISIT: 'cancel_visit',
  SEND_PRESENTATION: 'send_presentation',
  SEND_OFFER_LINK: 'send_offer_link',
  TALK_TO_TENANT: 'talk_to_tenant',
  TALK_TO_OWNER: 'talk_to_owner',
  TENANT_BEST_PRACTICES: 'tenant_best_practices',
  RESCHEDULE_WITH_TENANT: 'reschedule_with_tenant',
});

export const VISIT_STATUS_V2_REFERENCE_CASES = Object.freeze([
  {
    key: 'requested',
    referenceStatus: 'REQUESTED',
    referenceComponent: 'VisitRequestedCard',
    localCardStatus: VISITA_CARD_STATUS.WAITING_CONFIRMATION,
    expectedPrimaryAction: VISIT_DETAIL_STATUS_ACTIONS.CONFIRM_VISIT,
    tenantPrimaryAction: VISIT_DETAIL_STATUS_ACTIONS.TALK_TO_TENANT,
  },
  {
    key: 'confirmed',
    referenceStatus: 'CONFIRMED',
    referenceComponent: 'VisitConfirmedCard',
    localCardStatus: VISITA_CARD_STATUS.CONFIRMED,
    expectedPrimaryAction: VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION,
    tenantPrimaryAction: VISIT_DETAIL_STATUS_ACTIONS.TENANT_BEST_PRACTICES,
  },
  {
    key: 'canceled',
    referenceStatus: 'CANCELED',
    referenceComponent: 'VisitCanceledCard',
    localCardStatus: VISITA_CARD_STATUS.CANCELED,
  },
  {
    key: 'unavailable-hours',
    referenceStatus: 'UNAVAILABLE_HOURS',
    referenceComponent: 'VisitUnavailableHoursCard',
    localCardStatus: VISITA_CARD_STATUS.UNAVAILABLE_HOURS,
    expectedPrimaryAction: VISIT_DETAIL_STATUS_ACTIONS.RESCHEDULE_VISIT,
    tenantPrimaryAction: VISIT_DETAIL_STATUS_ACTIONS.RESCHEDULE_WITH_TENANT,
  },
  {
    key: 'schedule-now',
    referenceStatus: 'SCHEDULE_NOW',
    referenceComponent: 'VisitScheduleNowCard',
    localCardStatus: VISITA_CARD_STATUS.NOW,
    expectedFloatingAction: VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION,
  },
  {
    key: 'pending',
    referenceStatus: 'PENDING',
    referenceComponent: 'VisitPendingCard',
    localCardStatus: VISITA_CARD_STATUS.PENDING,
    expectedPrimaryAction: VISIT_DETAIL_STATUS_ACTIONS.FINISH_VISIT,
    expectedFloatingAction: VISIT_DETAIL_STATUS_ACTIONS.FINISH_VISIT,
  },
  {
    key: 'done',
    referenceStatus: 'DONE',
    referenceComponent: 'VisitDoneCard',
    localCardStatus: VISITA_CARD_STATUS.DONE,
    expectedFloatingAction: VISIT_DETAIL_STATUS_ACTIONS.SEND_OFFER_LINK,
  },
  {
    key: 'not-happened',
    referenceStatus: 'NOT_HAPPENED',
    referenceComponent: 'VisitNotHappenedCard',
    localCardStatus: VISITA_CARD_STATUS.NOT_HAPPENED,
  },
  {
    key: 'unsuccessful',
    referenceStatus: 'UNSUCCESSFUL',
    referenceComponent: 'VisitUnsuccessfulCard',
    localCardStatus: VISITA_CARD_STATUS.UNSUCCESSFUL,
  },
  {
    key: 'scheduled',
    referenceStatus: 'SCHEDULE_SCHEDULED',
    referenceComponent: 'VisitScheduleScheduledCard',
    localCardStatus: VISITA_CARD_STATUS.SCHEDULED,
    expectedFloatingAction: VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION,
    compatibilityOnly: true,
  },
]);

export const buildVisitStatusV2ReferenceByKey = () =>
  Object.fromEntries(
    VISIT_STATUS_V2_REFERENCE_CASES.map(item => [item.key, { ...item }])
  );

const statusAction = ({ key, label, icon, variant = 'primary' }) =>
  Object.freeze({
    key,
    label,
    icon,
    variant,
  });

const STATUS_ACTION_DEFINITIONS = Object.freeze({
  [VISIT_DETAIL_STATUS_ACTIONS.CONFIRM_VISIT]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.CONFIRM_VISIT,
    label: VISIT_DETAIL_TEXT.CONFIRM_VISIT,
    icon: 'i-lucide-circle-check',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.FINISH_VISIT]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.FINISH_VISIT,
    label: VISIT_DETAIL_TEXT.FINISH_VISIT,
    icon: 'i-lucide-flag',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.RESCHEDULE_VISIT]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.RESCHEDULE_VISIT,
    label: VISIT_DETAIL_TEXT.RESCHEDULE_VISIT,
    icon: 'i-lucide-calendar-clock',
    variant: 'ghost',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.CANCEL_VISIT]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.CANCEL_VISIT,
    label: VISIT_DETAIL_TEXT.CANCEL_VISIT,
    icon: 'i-lucide-calendar-x-2',
    variant: 'ghost',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION,
    label: VISIT_DETAIL_TEXT.SEND_PRESENTATION,
    icon: 'i-lucide-send',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.SEND_OFFER_LINK]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.SEND_OFFER_LINK,
    label: VISIT_DETAIL_TEXT.SEND_OFFER_LINK,
    icon: 'i-lucide-file-signature',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.TALK_TO_TENANT]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.TALK_TO_TENANT,
    label: VISIT_DETAIL_TEXT.TALK_TO_TENANT,
    icon: 'i-lucide-message-circle',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.TALK_TO_OWNER]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.TALK_TO_OWNER,
    label: VISIT_DETAIL_TEXT.TALK_TO_OWNER,
    icon: 'i-lucide-message-circle',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.TENANT_BEST_PRACTICES]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.TENANT_BEST_PRACTICES,
    label: VISIT_DETAIL_TEXT.TENANT_BEST_PRACTICES_BUTTON,
    icon: 'i-lucide-list-checks',
  }),
  [VISIT_DETAIL_STATUS_ACTIONS.RESCHEDULE_WITH_TENANT]: statusAction({
    key: VISIT_DETAIL_STATUS_ACTIONS.RESCHEDULE_WITH_TENANT,
    label: VISIT_DETAIL_TEXT.RESCHEDULE_WITH_TENANT,
    icon: 'i-lucide-calendar-clock',
  }),
});

const toText = value => String(value || '').trim();

const firstPresent = (...values) =>
  values.find(value => value !== undefined && value !== null && value !== '');

const snakeKey = key =>
  String(key).replace(/[A-Z]/g, char => `_${char.toLowerCase()}`);

const objectValue = (source, key) => {
  if (!source) return undefined;
  return source[key] ?? source[snakeKey(key)];
};

const numberValue = value => {
  if (value === undefined || value === null || value === '') return null;
  const normalized = Number(value);
  return Number.isFinite(normalized) ? normalized : null;
};

const moneyLabel = value => {
  const amount = numberValue(value);
  if (amount === null) return '';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(amount);
};

const compactMoneyLabel = value => {
  const amount = numberValue(value);
  if (amount === null) return '';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumSignificantDigits: 4,
  }).format(amount);
};

const firstObject = (...values) =>
  values.find(
    value => value && typeof value === 'object' && !Array.isArray(value)
  ) || {};

const sourceValue = (sources, ...keys) =>
  sources
    .flatMap(source => keys.map(key => objectValue(source, key)))
    .find(value => value !== undefined && value !== null && value !== '');

const tokenValue = value => toText(value).toLowerCase();

const booleanValue = (value, fallback = false) => {
  if (value === undefined || value === null || value === '') return fallback;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;

  return !['false', '0', 'no', 'nao', 'não'].includes(tokenValue(value));
};

const plainDateLabel = value => {
  if (!value) return '';
  const raw = toText(value);
  const isoDate = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDate) return `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}`;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};

export const visitAttributes = visit =>
  visit?.additionalAttributes || visit?.additional_attributes || {};

export const imovelAttributes = visit =>
  visit?.imovel?.additionalAttributes ||
  visit?.imovel?.additional_attributes ||
  {};

const visitSourceObjects = visit => [
  visitAttributes(visit),
  imovelAttributes(visit),
  visit || {},
  visit?.imovel || {},
];

const sectionObject = (visit, ...keys) => {
  const sources = visitSourceObjects(visit);
  return firstObject(
    ...sources.flatMap(source => keys.map(key => objectValue(source, key)))
  );
};

const ownerContactSource = visit => {
  const attrs = visitAttributes(visit);
  const imovelAttrs = imovelAttributes(visit);
  return firstObject(
    visit?.ownerContact,
    visit?.owner_contact,
    visit?.imovel?.ownerContact,
    visit?.imovel?.owner_contact,
    attrs.ownerContact,
    attrs.owner_contact,
    imovelAttrs.ownerContact,
    imovelAttrs.owner_contact
  );
};

export const visitContactId = visit =>
  visit?.contact?.id || visit?.contactId || visit?.contact_id;

export const visitImovelId = visit =>
  visit?.imovel?.id || visit?.imovelId || visit?.imovel_id;

export const visitConversationDisplayId = visit =>
  visit?.conversation?.id ||
  visit?.conversationId ||
  visit?.conversation_id ||
  visit?.conversationRecordId ||
  visit?.conversation_record_id;

export const visitBusinessContext = visit => {
  const value = firstPresent(
    visit?.businessContext,
    visit?.business_context,
    visit?.imovel?.businessContext,
    visit?.imovel?.business_context,
    visit?.imovel?.finalidade,
    visitAttributes(visit).businessContext,
    visitAttributes(visit).business_context
  );

  return ['venda', 'sale', 'for_sale', 'compra'].includes(
    toText(value).toLowerCase()
  )
    ? 'for_sale'
    : 'for_rent';
};

const formatDate = (value, options = {}) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: options.includeYear === false ? undefined : 'numeric',
    hour: options.includeTime ? '2-digit' : undefined,
    minute: options.includeTime ? '2-digit' : undefined,
    weekday: options.weekday,
  }).format(date);
};

export const visitDateTimeLabel = visit =>
  visit?.summary?.scheduledAtLabel ||
  visit?.summary?.scheduled_at_label ||
  formatDate(visit?.scheduledAt || visit?.scheduled_at, {
    includeTime: true,
  }) ||
  'Data não informada';

export const visitDateLabel = visit =>
  formatDate(visit?.scheduledAt || visit?.scheduled_at, {
    includeYear: true,
  }) || 'Data não informada';

export const visitTimeLabel = visit => {
  const date = new Date(visit?.scheduledAt || visit?.scheduled_at || '');
  if (Number.isNaN(date.getTime())) return 'Horário não informado';

  return new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const visitAddressLine = visit =>
  [
    firstPresent(visit?.imovel?.titulo, visit?.imovel?.endereco),
    visit?.imovel?.bairro,
    visit?.imovel?.cidade,
  ]
    .filter(Boolean)
    .map(toText)
    .join(', ') || 'Endereço não informado';

export const visitPropertyImage = visit => {
  const imovel = visit?.imovel || {};
  const attrs = imovelAttributes(visit);
  const medias = imovel.midias || imovel.media || attrs.midias || attrs.media;
  const firstMedia = Array.isArray(medias) ? medias[0] : medias;

  return (
    firstPresent(
      imovel.coverUrl,
      imovel.cover_url,
      imovel.thumbnail,
      imovel.thumbnail_url,
      imovel.imageUrl,
      imovel.image_url,
      firstMedia?.url,
      firstMedia?.src,
      firstMedia
    ) || ''
  );
};

export const visitStatusBadge = visit => {
  const cardStatus = getVisitaCardStatus(visit);
  if (cardStatus) {
    return {
      key: cardStatus,
      label: VISITA_CARD_STATUS_LABELS[cardStatus],
      className: VISITA_CARD_STATUS_CLASSES[cardStatus],
    };
  }

  return {
    key: visit?.status || '',
    label: getVisitaStatusLabel(visit?.status),
    className: getVisitaStatusClass(visit?.status),
  };
};

export const isVisitClosed = visit =>
  ['realizada', 'nao_compareceu', 'nao_sucedida', 'cancelada'].includes(
    visit?.status
  );

export const canFinishVisit = visit => visit?.id && !isVisitClosed(visit);

export const canConfirmVisit = visit =>
  ['solicitada', 'agendada'].includes(visit?.status);

export const isTenantLivingVisit = visit => {
  const attrs = visitAttributes(visit);
  const imovelAttrs = imovelAttributes(visit);
  const explicitFlag = firstPresent(
    visit?.tenantLiving,
    visit?.tenant_living,
    attrs.tenantLiving,
    attrs.tenant_living,
    visit?.imovel?.tenantLiving,
    visit?.imovel?.tenant_living,
    imovelAttrs.tenantLiving,
    imovelAttrs.tenant_living
  );

  if (explicitFlag !== undefined && explicitFlag !== null) {
    return booleanValue(explicitFlag);
  }

  const occupancy = tokenValue(
    firstPresent(
      visit?.occupancy,
      visit?.ocupacao,
      attrs.occupancy,
      attrs.ocupacao,
      attrs.houseOccupancy,
      attrs.house_occupancy,
      visit?.imovel?.occupancy,
      visit?.imovel?.ocupacao,
      imovelAttrs.occupancy,
      imovelAttrs.ocupacao,
      imovelAttrs.houseOccupancy,
      imovelAttrs.house_occupancy
    )
  );

  return [
    'tenant',
    'tenant_living',
    'morador',
    'occupied',
    'with_tenant_living',
    'keys_with_tenant_living',
  ].includes(occupancy);
};

export const tenantContactInfo = visit => {
  const attrs = visitAttributes(visit);
  const imovelAttrs = imovelAttributes(visit);
  return firstObject(
    visit?.tenantContact,
    visit?.tenant_contact,
    attrs.tenantContact,
    attrs.tenant_contact,
    attrs.tenant,
    visit?.imovel?.tenantContact,
    visit?.imovel?.tenant_contact,
    imovelAttrs.tenantContact,
    imovelAttrs.tenant_contact,
    imovelAttrs.tenant
  );
};

export const tenantName = visit =>
  firstPresent(
    tenantContactInfo(visit).firstName,
    tenantContactInfo(visit).first_name,
    tenantContactInfo(visit).name,
    tenantContactInfo(visit).nome
  ) || 'morador';

export const tenantPhone = visit =>
  firstPresent(
    tenantContactInfo(visit).phoneNumber,
    tenantContactInfo(visit).phone_number,
    tenantContactInfo(visit).phone,
    tenantContactInfo(visit).telefone
  ) || '';

const cancellationReason = visit =>
  tokenValue(
    firstPresent(
      visit?.structuredStatus?.reason,
      visit?.structured_status?.reason,
      visit?.structuredStatus?.cancellationReason,
      visit?.structured_status?.cancellation_reason,
      visitAttributes(visit).reason,
      visitAttributes(visit).cancellationReason,
      visitAttributes(visit).cancellation_reason
    )
  );

const isRequestExpiredCancellation = visit =>
  ['request_expired', 'expired', 'solicitacao_expirada'].includes(
    cancellationReason(visit)
  );

const statusActionByKey = key => STATUS_ACTION_DEFINITIONS[key];

const buildHeroActions = ({
  primary,
  secondary = [],
  floating = null,
} = {}) => {
  const primaryAction = primary ? statusActionByKey(primary) : null;
  const secondaryActions = secondary.map(statusActionByKey).filter(Boolean);

  return {
    primaryAction,
    secondaryActions,
    actions: [primaryAction, ...secondaryActions].filter(Boolean),
    floatingAction: floating ? statusActionByKey(floating) : null,
  };
};

const visitConfirmationDeadline = visit =>
  firstPresent(
    visit?.visitExpirationDate,
    visit?.visit_expiration_date,
    visitAttributes(visit).confirmationExpirationDate,
    visitAttributes(visit).confirmation_expiration_date,
    visitAttributes(visit).visitExpirationDate,
    visitAttributes(visit).visit_expiration_date,
    visit?.scheduledAt,
    visit?.scheduled_at
  );

const visitDeadlineParts = visit => {
  const date = new Date(visitConfirmationDeadline(visit) || '');
  if (Number.isNaN(date.getTime())) {
    return {
      date: visitDateLabel(visit),
      time: visitTimeLabel(visit),
    };
  }

  return {
    date: new Intl.DateTimeFormat('pt-BR', {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
    }).format(date),
    time: new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    }).format(date),
  };
};

const requestedStatusDescription = visit => {
  const deadline = visitDeadlineParts(visit);

  return VISIT_DETAIL_TEXT.STATUS_REQUESTED_DESCRIPTION.replace(
    '{date}',
    deadline.date
  ).replace('{time}', deadline.time);
};

export const statusHero = visit => {
  const cardStatus = getVisitaCardStatus(visit);
  const badge = visitStatusBadge(visit);
  const isTenantLiving = isTenantLivingVisit(visit);
  const common = {
    label: badge.label,
    badgeClass: badge.className,
    cardStatus,
    isTenantLiving,
  };

  if (cardStatus === VISITA_CARD_STATUS.PENDING) {
    return {
      ...common,
      icon: 'i-lucide-flag',
      title: VISIT_DETAIL_TEXT.STATUS_PENDING_TITLE,
      description: VISIT_DETAIL_TEXT.STATUS_PENDING_DESCRIPTION,
      toneClass: 'border-amber-200 bg-amber-50 text-amber-900',
      ...buildHeroActions({
        primary: VISIT_DETAIL_STATUS_ACTIONS.FINISH_VISIT,
        floating: VISIT_DETAIL_STATUS_ACTIONS.FINISH_VISIT,
      }),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.WAITING_CONFIRMATION) {
    return {
      ...common,
      icon: 'i-lucide-clock',
      title: VISIT_DETAIL_TEXT.STATUS_REQUESTED_TITLE,
      description: isTenantLiving
        ? VISIT_DETAIL_TEXT.STATUS_REQUESTED_TENANT_DESCRIPTION
        : requestedStatusDescription(visit),
      toneClass: 'border-amber-200 bg-amber-50 text-amber-900',
      ...buildHeroActions({
        primary: isTenantLiving
          ? VISIT_DETAIL_STATUS_ACTIONS.TALK_TO_TENANT
          : VISIT_DETAIL_STATUS_ACTIONS.CONFIRM_VISIT,
      }),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.CONFIRMED) {
    return {
      ...common,
      icon: 'i-lucide-calendar-check',
      title: VISIT_DETAIL_TEXT.STATUS_CONFIRMED_TITLE,
      description: isTenantLiving
        ? VISIT_DETAIL_TEXT.STATUS_CONFIRMED_TENANT_DESCRIPTION
        : VISIT_DETAIL_TEXT.STATUS_CONFIRMED_DESCRIPTION,
      toneClass: 'border-emerald-200 bg-emerald-50 text-emerald-900',
      ...buildHeroActions({
        primary: isTenantLiving
          ? VISIT_DETAIL_STATUS_ACTIONS.TENANT_BEST_PRACTICES
          : VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION,
      }),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.SCHEDULED) {
    return {
      ...common,
      icon: 'i-lucide-calendar-days',
      title: VISIT_DETAIL_TEXT.STATUS_SCHEDULED_TITLE,
      description: VISIT_DETAIL_TEXT.STATUS_SCHEDULED_DESCRIPTION,
      toneClass: 'border-sky-200 bg-sky-50 text-sky-900',
      ...buildHeroActions({
        floating: VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION,
      }),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.UNAVAILABLE_HOURS) {
    return {
      ...common,
      icon: 'i-lucide-timer-off',
      title: VISIT_DETAIL_TEXT.STATUS_UNAVAILABLE_TITLE,
      description: isTenantLiving
        ? VISIT_DETAIL_TEXT.STATUS_UNAVAILABLE_TENANT_DESCRIPTION
        : VISIT_DETAIL_TEXT.STATUS_UNAVAILABLE_DESCRIPTION,
      toneClass: 'border-orange-200 bg-orange-50 text-orange-900',
      ...buildHeroActions({
        primary: isTenantLiving
          ? VISIT_DETAIL_STATUS_ACTIONS.RESCHEDULE_WITH_TENANT
          : VISIT_DETAIL_STATUS_ACTIONS.RESCHEDULE_VISIT,
      }),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.NOW) {
    return {
      ...common,
      icon: 'i-lucide-user-check',
      title: VISIT_DETAIL_TEXT.STATUS_NOW_TITLE,
      description: VISIT_DETAIL_TEXT.STATUS_NOW_DESCRIPTION,
      toneClass: 'border-lais-primary/20 bg-lais-primary-50/50 text-lais-text',
      ...buildHeroActions({
        floating: VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION,
      }),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.DONE) {
    return {
      ...common,
      icon: 'i-lucide-circle-check',
      title: VISIT_DETAIL_TEXT.STATUS_DONE_TITLE,
      description: VISIT_DETAIL_TEXT.STATUS_DONE_DESCRIPTION,
      toneClass: 'border-emerald-200 bg-emerald-50 text-emerald-900',
      ...buildHeroActions({
        floating: VISIT_DETAIL_STATUS_ACTIONS.SEND_OFFER_LINK,
      }),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.CANCELED) {
    const canRecoverCanceledRequest = isRequestExpiredCancellation(visit);
    let canceledPrimaryAction = null;
    if (canRecoverCanceledRequest) {
      canceledPrimaryAction = isTenantLiving
        ? VISIT_DETAIL_STATUS_ACTIONS.TALK_TO_TENANT
        : VISIT_DETAIL_STATUS_ACTIONS.TALK_TO_OWNER;
    }
    return {
      ...common,
      icon: 'i-lucide-circle-alert',
      title: VISIT_DETAIL_TEXT.STATUS_CANCELED_TITLE,
      description: VISIT_DETAIL_TEXT.STATUS_CANCELED_DESCRIPTION,
      toneClass: 'border-rose-200 bg-rose-50 text-rose-900',
      ...buildHeroActions({
        primary: canceledPrimaryAction,
      }),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.NOT_HAPPENED) {
    return {
      ...common,
      icon: 'i-lucide-circle-alert',
      title: VISIT_DETAIL_TEXT.STATUS_UNSUCCESSFUL_TITLE,
      description: VISIT_DETAIL_TEXT.STATUS_NOT_HAPPENED_DESCRIPTION,
      toneClass: 'border-rose-200 bg-rose-50 text-rose-900',
      ...buildHeroActions(),
    };
  }

  if (cardStatus === VISITA_CARD_STATUS.UNSUCCESSFUL) {
    return {
      ...common,
      icon: 'i-lucide-circle-alert',
      title: VISIT_DETAIL_TEXT.STATUS_UNSUCCESSFUL_TITLE,
      description: VISIT_DETAIL_TEXT.STATUS_UNSUCCESSFUL_DESCRIPTION,
      toneClass: 'border-rose-200 bg-rose-50 text-rose-900',
      ...buildHeroActions(),
    };
  }

  return {
    ...common,
    icon: 'i-lucide-calendar-clock',
    title: badge.label || 'Visita agendada',
    description:
      'Confirme dados de entrada, visitante, responsável e ações antes do horário combinado.',
    toneClass: 'border-lais-primary/20 bg-lais-primary-50/50 text-lais-text',
    ...buildHeroActions({
      floating: VISIT_DETAIL_STATUS_ACTIONS.SEND_PRESENTATION,
    }),
  };
};

export const visitInfoRows = visit =>
  [
    { label: 'Data da visita', value: visitDateLabel(visit) },
    { label: 'Horário', value: visitTimeLabel(visit) },
    { label: 'Tipo de visita', value: visitIntentionLabel(visit) },
    {
      label: 'Corretor responsável',
      value: visit?.user?.name || visit?.agent?.name || 'Não informado',
    },
    {
      label: 'Código da visita',
      value:
        firstPresent(
          visit?.visitCode,
          visit?.visit_code,
          visitAttributes(visit).visitCode,
          visitAttributes(visit).visit_code,
          visit?.id
        ) || 'Não informado',
    },
  ].filter(row => row.value);

export const visitFeedbackRows = visit => {
  const surveyResponse =
    visit?.visitFeedbackSurvey ||
    visit?.visit_feedback_survey ||
    visit?.surveyResponse ||
    visit?.survey_response ||
    {};
  const feedback =
    visit?.visitFeedback ||
    visit?.visit_feedback ||
    surveyResponse?.visitFeedback ||
    {};
  const answers = surveyResponse?.answers || {};
  const rating = firstPresent(
    feedback?.ratings?.overallRating,
    feedback?.ratings?.overall_rating,
    feedback?.ratings?.rating,
    answers?.overallRating,
    answers?.overall_rating,
    answers?.rating
  );
  const body = firstPresent(
    feedback?.body,
    feedback?.feedback,
    answers?.body,
    answers?.feedback,
    visit?.feedback
  );
  const submittedAt = firstPresent(
    feedback?.submittedAt,
    feedback?.submitted_at,
    surveyResponse?.respondedAt,
    surveyResponse?.responded_at
  );

  return [
    {
      label: 'Status',
      value: firstPresent(
        surveyResponse?.status,
        feedback?.status,
        body && 'Respondido'
      ),
    },
    { label: 'Nota geral', value: rating ? `${rating}/5` : '' },
    { label: 'Resposta', value: body },
    {
      label: 'Respondido em',
      value: submittedAt ? formatDate(submittedAt, { includeTime: true }) : '',
    },
  ].filter(
    row => row.value !== '' && row.value !== undefined && row.value !== null
  );
};

export const propertyInfoRows = visit =>
  [
    { label: 'Endereço', value: visitAddressLine(visit) },
    { label: 'ID do imóvel', value: visitImovelId(visit) },
    {
      label: 'Finalidade',
      value: visitBusinessContext(visit) === 'for_sale' ? 'Venda' : 'Aluguel',
    },
    {
      label: 'Dormitórios',
      value: firstPresent(visit?.imovel?.quartos, visit?.imovel?.bedrooms),
    },
    {
      label: 'Área',
      value: firstPresent(visit?.imovel?.area_util, visit?.imovel?.areaTotal)
        ? `${firstPresent(visit?.imovel?.area_util, visit?.imovel?.areaTotal)} m²`
        : '',
    },
    {
      label: 'Vagas',
      value: firstPresent(
        visit?.imovel?.vagas_garagem,
        visit?.imovel?.parkingSpots
      ),
    },
  ].filter(
    row => row.value !== '' && row.value !== undefined && row.value !== null
  );

const houseCode = visit =>
  firstPresent(
    visit?.imovel?.displayCode,
    visit?.imovel?.display_code,
    visit?.imovel?.externalId,
    visit?.imovel?.external_id,
    imovelAttributes(visit).displayCode,
    imovelAttributes(visit).display_code,
    imovelAttributes(visit).houseId,
    imovelAttributes(visit).house_id,
    visitImovelId(visit)
  );

const housePublishedAt = visit => {
  const listings = firstPresent(
    visit?.imovel?.listings,
    imovelAttributes(visit).listings
  );
  const context = visitBusinessContext(visit);
  const listing = Array.isArray(listings)
    ? listings.find(item =>
        [item.businessContext, item.business_context].includes(
          context === 'for_sale' ? 'SALE' : 'RENT'
        )
      )
    : null;

  return (
    firstPresent(
      listing?.lastPublicationDate,
      context === 'for_rent' ? visit?.imovel?.publishDate : ''
    ) || ''
  );
};

const isExclusiveListing = visit => {
  const sources = visitSourceObjects(visit);
  const explicit = sourceValue(
    sources,
    'isExclusive',
    'is_exclusive',
    'exclusive'
  );
  return booleanValue(explicit);
};

const listingUrl = visit =>
  firstPresent(
    visit?.imovel?.linkExterno,
    visit?.imovel?.link_externo,
    visit?.imovel?.listingUrl,
    visit?.imovel?.listing_url,
    imovelAttributes(visit).linkExterno,
    imovelAttributes(visit).link_externo,
    imovelAttributes(visit).listingUrl,
    imovelAttributes(visit).listing_url,
    imovelAttributes(visit).publicUrl,
    imovelAttributes(visit).public_url
  );

export const buildHouseSummary = visit => {
  const code = houseCode(visit);
  const publishDate = plainDateLabel(housePublishedAt(visit));
  const href = listingUrl(visit);
  const tags =
    visitBusinessContext(visit) === 'for_rent' && isExclusiveListing(visit)
      ? [VISIT_DETAIL_TEXT.EXCLUSIVE_TAG_LABEL]
      : [];

  return {
    key: 'house-summary',
    code,
    title: VISIT_DETAIL_TEXT.CARD_HOUSE_ID_LABEL.replace(
      '{houseId}',
      code || 'Não informado'
    ),
    description: publishDate
      ? VISIT_DETAIL_TEXT.CARD_PUBLISH_DATE.replace(
          '{publishDate}',
          publishDate
        )
      : '',
    image: visitPropertyImage(visit),
    tags,
    actions: [
      {
        key: 'copy-house-id',
        type: 'copy',
        label: VISIT_DETAIL_TEXT.COPY_HOUSE_ID,
        icon: 'i-lucide-copy',
        clipboardText: code ? String(code) : '',
        disabled: !code,
      },
      {
        key: 'go-to-listing',
        type: 'open',
        label: VISIT_DETAIL_TEXT.GO_TO_LISTING_BUTTON,
        icon: 'i-lucide-external-link',
        href,
        emit: href ? '' : 'openListing',
      },
    ],
  };
};

const propertyTotalCost = visit => {
  const direct = numberValue(
    sourceValue(
      visitSourceObjects(visit),
      'totalCost',
      'total_cost',
      'monthlyCost',
      'monthly_cost'
    )
  );
  if (direct !== null) return direct;

  const priceBreakdown = firstPresent(
    visit?.imovel?.priceBreakdown,
    visit?.imovel?.price_breakdown
  );
  if (Array.isArray(priceBreakdown)) {
    const totalRow = priceBreakdown.find(row =>
      ['TOTAL_COST', 'total_cost'].includes(row.kind)
    );
    const total = numberValue(totalRow?.value);
    if (total !== null) return total;
  }

  return [
    visit?.imovel?.valor_aluguel,
    visit?.imovel?.valorAluguel,
    visit?.imovel?.valor_condominio,
    visit?.imovel?.valorCondominio,
    visit?.imovel?.valor_iptu,
    visit?.imovel?.valorIptu,
  ].reduce((sum, value) => sum + (numberValue(value) || 0), 0);
};

const requiredIncome = totalCost => Math.round((totalCost * 2.5) / 100) * 100;

const rentAdministrator = visit =>
  tokenValue(
    firstPresent(
      visit?.imovel?.rentalAdministrator,
      visit?.imovel?.rental_administrator,
      imovelAttributes(visit).rentalAdministrator,
      imovelAttributes(visit).rental_administrator
    )
  );

const isThirdPartyRent = visit =>
  ['terceiro', 'third_party', 'third-party'].includes(rentAdministrator(visit));

const isOwnerManagedRent = visit =>
  ['owner', 'proprietario', 'proprietário'].includes(rentAdministrator(visit));

const isThirdPartySale = visit => {
  const sources = visitSourceObjects(visit);
  const ownership = tokenValue(
    sourceValue(sources, 'ownership', 'listingOwnership', 'listing_ownership')
  );

  return (
    ['terceiro', 'third_party', 'third-party'].includes(ownership) ||
    booleanValue(
      sourceValue(
        sources,
        'isOwnedByThirdParty',
        'is_owned_by_third_party',
        'thirdPartyOwnership',
        'third_party_ownership'
      ),
      false
    )
  );
};

const houseAvailabilityType = visit =>
  tokenValue(
    sourceValue(
      visitSourceObjects(visit),
      'availabilityType',
      'availability_type',
      'entryAvailabilityType',
      'entry_availability_type'
    )
  );

const houseAvailabilityDescription = visit => {
  const sources = visitSourceObjects(visit);
  const type = houseAvailabilityType(visit);
  const reason = sourceValue(
    sources,
    'awaitingAvailabilityReason',
    'awaiting_availability_reason',
    'availabilityReason',
    'availability_reason'
  );
  const movingDate = plainDateLabel(
    sourceValue(sources, 'movingDate', 'moving_date', 'availableFrom')
  );
  const daysToVacate =
    numberValue(sourceValue(sources, 'daysToVacate', 'days_to_vacate')) || 0;

  if (['exact', 'data_exata'].includes(type)) {
    return (
      reason
        ? VISIT_DETAIL_TEXT.AVAILABILITY_EXACT_WITH_REASON
        : VISIT_DETAIL_TEXT.AVAILABILITY_EXACT
    )
      .replace('{movingDate}', movingDate || 'data informada pelo proprietário')
      .replace('{reason}', reason || '');
  }

  if (['flexible', 'flexivel', 'flexível'].includes(type)) {
    return (
      reason
        ? VISIT_DETAIL_TEXT.AVAILABILITY_FLEXIBLE_WITH_REASON
        : VISIT_DETAIL_TEXT.AVAILABILITY_FLEXIBLE
    )
      .replace('{daysToVacate}', daysToVacate || 'alguns')
      .replace('{reason}', reason || '');
  }

  return VISIT_DETAIL_TEXT.AVAILABILITY_IMMEDIATE;
};

const customOfferSection = visit => {
  if (visitBusinessContext(visit) === 'for_sale') return null;

  const allowed = booleanValue(
    sourceValue(
      visitSourceObjects(visit),
      'allowsCustomOffer',
      'allows_custom_offer',
      'customOfferAllowed',
      'custom_offer_allowed',
      'isCustomOfferAllowed',
      'is_custom_offer_allowed'
    ),
    false
  );

  return {
    key: 'custom-offer',
    title: VISIT_DETAIL_TEXT.CUSTOM_OFFER_TITLE,
    icon: 'i-lucide-hand-coins',
    subtitle: allowed
      ? VISIT_DETAIL_TEXT.CUSTOM_OFFER_ALLOWED_SUBTITLE
      : VISIT_DETAIL_TEXT.CUSTOM_OFFER_NOT_ALLOWED_SUBTITLE,
  };
};

const incomeProofSection = visit => {
  if (visitBusinessContext(visit) === 'for_sale') return null;

  const totalCost = propertyTotalCost(visit);
  if (!totalCost) return null;

  return {
    key: 'income-proof',
    title: VISIT_DETAIL_TEXT.INCOME_PROOF_TITLE,
    icon: 'i-lucide-badge-check',
    subtitle: VISIT_DETAIL_TEXT.INCOME_PROOF_SUBTITLE.replace(
      '{income}',
      compactMoneyLabel(requiredIncome(totalCost))
    ),
  };
};

const entryAvailabilitySection = visit => {
  if (visitBusinessContext(visit) === 'for_sale') return null;

  return {
    key: 'entry-availability',
    title: VISIT_DETAIL_TEXT.ENTRY_AVAILABILITY_TITLE,
    icon: 'i-lucide-door-open',
    subtitle: houseAvailabilityDescription(visit),
  };
};

const thirdPartyDialogParagraphs = businessContext =>
  businessContext === 'for_sale'
    ? [
        'O cliente tem acesso a maior plataforma de moradia do país para acompanhar a sua compra e conta com os benefícios como:',
        'Toda a tecnologia e atendimento para fechar o melhor negócio.',
        'Acesso à nossa assessoria de financiamento para buscar as melhores taxas e conduzir o processo com nossos bancos parceiros.',
        'Raio-X completo de toda a documentação antes do comprador fechar negócio.',
        'Time especializado em todas as etapas do processo.',
      ]
    : [
        'São imóveis anunciados e administrados por imobiliárias parceiras.',
        'É preciso pagar a Fiança Locatícia junto ao boleto de aluguel. É seguro, simples, direto pelo aplicativo e não precisa de fiador.',
        'A plataforma acompanha até a assinatura do contrato. Depois, a imobiliária parceira administra o aluguel, cuidando de pagamentos, reparos e muito mais.',
        'Os contratos de intermediação da locação são feitos pela plataforma e os de administração são feitos pela imobiliária parceira.',
        'Na assinatura do contrato será informado qual é a imobiliária parceira responsável pela administração do imóvel.',
      ];

const thirdPartyOwnershipSection = (visit, { companyName } = {}) => {
  const businessContext = visitBusinessContext(visit);
  const visible =
    businessContext === 'for_sale'
      ? isThirdPartySale(visit)
      : isThirdPartyRent(visit);
  if (!visible) return null;

  return {
    key: 'third-party-ownership',
    title:
      businessContext === 'for_sale'
        ? VISIT_DETAIL_TEXT.THIRD_PARTY_OWNERSHIP_TITLE_SALE
        : VISIT_DETAIL_TEXT.THIRD_PARTY_OWNERSHIP_TITLE_RENT,
    icon: 'i-lucide-building-2',
    subtitle: (businessContext === 'for_sale'
      ? VISIT_DETAIL_TEXT.THIRD_PARTY_OWNERSHIP_SUBTITLE_SALE
      : VISIT_DETAIL_TEXT.THIRD_PARTY_OWNERSHIP_SUBTITLE_RENT
    ).replaceAll('{companyName}', companyName),
    actions: [
      {
        key: 'third-party-info',
        type: 'dialog',
        label: VISIT_DETAIL_TEXT.THIRD_PARTY_OWNERSHIP_DIALOG_TITLE,
        icon: 'i-lucide-info',
        dialog: {
          title: VISIT_DETAIL_TEXT.THIRD_PARTY_OWNERSHIP_DIALOG_TITLE,
          paragraphs: thirdPartyDialogParagraphs(businessContext),
          confirmLabel: VISIT_DETAIL_TEXT.MANAGED_BY_OWNER_MODAL_BUTTON,
        },
      },
    ],
  };
};

const managedByOwnerSection = (visit, { companyName } = {}) => {
  if (
    visitBusinessContext(visit) === 'for_sale' ||
    !isOwnerManagedRent(visit)
  ) {
    return null;
  }

  return {
    key: 'managed-by-owner',
    title: VISIT_DETAIL_TEXT.MANAGED_BY_OWNER_TITLE,
    icon: 'i-lucide-house-plus',
    subtitle: VISIT_DETAIL_TEXT.MANAGED_BY_OWNER_DESCRIPTION.replace(
      '{companyName}',
      companyName
    ),
    actions: [
      {
        key: 'managed-by-owner-info',
        type: 'dialog',
        label: VISIT_DETAIL_TEXT.MANAGED_BY_OWNER_BUTTON,
        icon: 'i-lucide-info',
        dialog: {
          title: VISIT_DETAIL_TEXT.MANAGED_BY_OWNER_MODAL_TITLE,
          paragraphs: [
            VISIT_DETAIL_TEXT.MANAGED_BY_OWNER_MODAL_DESCRIPTION.replace(
              '{companyName}',
              companyName
            ),
          ],
          confirmLabel: VISIT_DETAIL_TEXT.MANAGED_BY_OWNER_MODAL_BUTTON,
        },
      },
    ],
  };
};

export const buildHouseDetailSections = (
  visit,
  { companyName = 'Imudei' } = {}
) =>
  [
    thirdPartyOwnershipSection(visit, { companyName }),
    managedByOwnerSection(visit, { companyName }),
    incomeProofSection(visit),
    customOfferSection(visit),
    entryAvailabilitySection(visit),
  ].filter(Boolean);

export const visitorInfoRows = visit =>
  [
    { label: 'Nome', value: visit?.contact?.name || 'Cliente não informado' },
    {
      label: 'Telefone',
      value: visit?.contact?.phoneNumber || visit?.contact?.phone_number,
    },
    { label: 'E-mail', value: visit?.contact?.email },
    {
      label: 'Check-in',
      value:
        visit?.checkinStatus === 'confirmed' ||
        visit?.checkin_status === 'confirmed' ||
        visit?.checkinDone ||
        visit?.checkin_done
          ? 'Confirmado'
          : 'Pendente',
    },
  ].filter(row => row.value);

const entryAccessSource = visit =>
  firstPresent(
    visit?.entryAccess,
    visit?.entry_access,
    visit?.imovel?.entryAccess,
    visit?.imovel?.entry_access,
    visitAttributes(visit).entryAccess,
    visitAttributes(visit).entry_access,
    imovelAttributes(visit).entryAccess,
    imovelAttributes(visit).entry_access
  ) || {};

export const entryInfoRows = visit => {
  const entry = entryAccessSource(visit);
  return [
    {
      label: 'Entrada',
      value:
        firstPresent(entry.accessLabel, entry.access_label, entry.label) ||
        entryAccessLabel(
          firstPresent(
            entry.accessKey,
            entry.access_key,
            entry.kind,
            entry.type,
            visitAttributes(visit).entryAuthorization,
            visitAttributes(visit).entry_authorization
          )
        ),
    },
    {
      label: 'Responsável',
      value: firstPresent(entry.responsibleName, entry.responsible_name),
    },
    {
      label: 'Telefone do responsável',
      value: firstPresent(entry.responsiblePhone, entry.responsible_phone),
    },
    {
      label: 'Endereço de retirada',
      value: firstPresent(entry.responsibleAddress, entry.responsible_address),
    },
    {
      label: 'Instruções',
      value: firstPresent(entry.instructions, visit?.observacoes),
    },
  ].filter(row => row.value);
};

export const responsibleInfoRows = visit => {
  const attrs = visitAttributes(visit);
  const imovelAttrs = imovelAttributes(visit);
  const entry = entryAccessSource(visit);
  const owner = ownerContactSource(visit);
  return [
    {
      label: 'Nome',
      value: firstPresent(
        owner.name,
        owner.nome,
        attrs.ownerName,
        attrs.owner_name,
        entry.responsibleName,
        entry.responsible_name
      ),
    },
    {
      label: 'Telefone',
      value: firstPresent(
        owner.phoneNumber,
        owner.phone_number,
        owner.phone,
        owner.cellphone,
        attrs.ownerPhone,
        attrs.owner_phone,
        imovelAttrs.ownerPhone,
        imovelAttrs.owner_phone,
        entry.responsiblePhone,
        entry.responsible_phone
      ),
    },
    {
      label: 'Papel',
      value:
        firstPresent(
          attrs.responsibleRole,
          attrs.responsible_role,
          imovelAttrs.responsibleRole,
          imovelAttrs.responsible_role
        ) || 'Responsável pela entrada',
    },
  ].filter(row => row.value);
};

export const offerInfoRows = visit => [
  {
    label: 'Propostas em andamento',
    value:
      firstPresent(
        visitAttributes(visit).proposalsInProgressQuantity,
        visitAttributes(visit).proposals_in_progress_quantity,
        visit?.contact?.proposalsInProgressQuantity,
        visit?.contact?.proposals_in_progress_quantity
      ) || '0',
  },
  {
    label: 'Último envio',
    value: firstPresent(
      visitAttributes(visit).lastOfferLinkSentAt,
      visitAttributes(visit).last_offer_link_sent_at,
      visitAttributes(visit).agendaQuickActions?.offer?.completedAt,
      visitAttributes(visit).agenda_quick_actions?.offer?.completed_at
    )
      ? 'Link de proposta enviado'
      : 'Nenhum link enviado',
  },
];

const pluralProgressLabel = (count, zero, one, many) => {
  if (count === 1) return one;
  if (count === 0) return zero;
  return many;
};

const ciqSource = visit =>
  sectionObject(visit, 'ciq', 'ciqInfo', 'ciq_info', 'consultantInfo');

const ciqWhatsAppMessage = ({ ciqName, agentName, companyName, visit }) =>
  [
    `Olá, ${ciqName || 'consultor'}! Sou ${agentName || 'corretor'} e trabalho no time de corretores parceiros do ${companyName}.`,
    `Muito prazer! Tenho uma visita no imóvel ${visitAddressLine(visit)} e preciso do seu auxílio.`,
  ].join(' ');

const ciqSection = (visit, { companyName, agentName } = {}) => {
  const ciq = ciqSource(visit);
  const acceptsWhatsApp = sourceValue([ciq], 'acceptsWhatsApp');
  const name = firstPresent(ciq.name, ciq.nome, ciq.displayName);
  const phone = firstPresent(ciq.phone, ciq.phoneNumber, ciq.phone_number);

  if ((!name && !phone && !ciq.id) || acceptsWhatsApp === false) return null;

  const message = ciqWhatsAppMessage({
    ciqName: name,
    agentName,
    companyName,
    visit,
  });
  const href = buildWhatsappLink(phone, message);

  return {
    key: 'ciq',
    title: `${VISIT_DETAIL_SECTION_TITLES.CIQ} ${companyName}`,
    icon: 'i-lucide-user-round-check',
    subtitle: VISIT_DETAIL_TEXT.CIQ_DESCRIPTION,
    rows: [
      { label: 'Nome', value: name },
      { label: 'Telefone', value: phone },
    ].filter(row => row.value),
    actions: href
      ? [
          {
            key: 'ciq-whatsapp',
            label: VISIT_DETAIL_TEXT.CIQ_WHATSAPP_LABEL,
            icon: 'i-ph-whatsapp-logo',
            href,
          },
        ]
      : [],
  };
};

const ownerSection = visit => {
  const owner = ownerContactSource(visit);
  const attrs = visitAttributes(visit);
  const imovelAttrs = imovelAttributes(visit);
  const name = firstPresent(
    owner.name,
    owner.nome,
    attrs.ownerName,
    attrs.owner_name,
    imovelAttrs.ownerName,
    imovelAttrs.owner_name
  );
  const phone = firstPresent(
    owner.phoneNumber,
    owner.phone_number,
    owner.phone,
    owner.cellphone,
    attrs.ownerPhone,
    attrs.owner_phone,
    imovelAttrs.ownerPhone,
    imovelAttrs.owner_phone
  );

  if (!name && !phone) return null;

  return {
    key: 'owner',
    title: VISIT_DETAIL_SECTION_TITLES.OWNER,
    icon: 'i-lucide-house-plus',
    rows: [
      { label: 'Nome', value: name },
      {
        label: 'Telefone',
        value: phone || VISIT_DETAIL_TEXT.OWNER_WITH_NO_PHONE,
      },
    ].filter(row => row.value),
    actions: [
      {
        key: 'talk-owner',
        label: VISIT_DETAIL_TEXT.TALK_TO_OWNER_HELP,
        icon: 'i-lucide-message-circle',
        emit: 'talkOwner',
      },
    ],
  };
};

const propertyResponsibleSection = (visit, { companyName } = {}) => {
  const responsible = sectionObject(
    visit,
    'propertyResponsible',
    'property_responsible',
    'listingRepresentative',
    'listing_representative'
  );
  const hiddenChat = sectionObject(
    visit,
    'hiddenChatInformation',
    'hidden_chat_information'
  );
  const name = firstPresent(
    responsible.name,
    responsible.nome,
    responsible.companyName,
    responsible.company_name,
    hiddenChat.title,
    VISIT_DETAIL_TEXT.PROPERTY_RESPONSIBLE_PARTNER
  );
  const phone = firstPresent(
    responsible.phone,
    responsible.phoneNumber,
    responsible.phone_number
  );
  const note = firstPresent(
    responsible.note,
    responsible.observation,
    responsible.description,
    hiddenChat.text,
    'Não se preocupe, temos um time para confirmar todas as visitas com imobiliárias parceiras.'
  );

  return {
    key: 'property-responsible',
    title: VISIT_DETAIL_SECTION_TITLES.PROPERTY_RESPONSIBLE,
    icon: 'i-lucide-building-2',
    subtitle: name,
    rows: [
      { label: 'Canal', value: phone },
      { label: 'Orientação', value: note },
    ].filter(row => row.value),
    actions: [
      {
        key: 'talk-secretary',
        label: VISIT_DETAIL_TEXT.TALK_TO_SECRETARY.replace(
          '{companyName}',
          companyName
        ),
        icon: 'i-lucide-external-link',
        emit: 'openResponsibleInfo',
      },
    ],
  };
};

const reservationSection = (visit, { companyName } = {}) => {
  if (visitBusinessContext(visit) === 'for_sale') return null;

  const reservation = sectionObject(visit, 'reservation', 'reservationInfo');
  const allowed =
    sourceValue([reservation], 'allowed', 'enabled', 'available') !== false;
  const value = firstPresent(
    reservation.value,
    reservation.amount,
    reservation.price,
    sourceValue(visitSourceObjects(visit), 'reservationValue')
  );

  return {
    key: 'reservation',
    title: VISIT_DETAIL_SECTION_TITLES.RESERVATION,
    icon: 'i-lucide-badge-dollar-sign',
    subtitle: VISIT_DETAIL_TEXT.RESERVATION_TITLE,
    rows: [
      {
        label: VISIT_DETAIL_TEXT.RESERVATION_TITLE,
        value: allowed
          ? moneyLabel(value) || VISIT_DETAIL_TEXT.RESERVATION_DESCRIPTION
          : VISIT_DETAIL_TEXT.RESERVATION_NOT_ALLOWED,
      },
      {
        label: VISIT_DETAIL_TEXT.RESERVATION_HOW_IT_WORKS,
        value: `A opção fica disponível depois que a proposta é aceita. Após o pagamento, só a pessoa que reservou negocia pelo ${companyName}.`,
      },
      {
        label: 'Condição',
        value: 'Só é possível reservar um imóvel por vez.',
      },
    ],
  };
};

const rentProgressCount = (visit, key) => {
  const progress = sectionObject(visit, 'rentProgress', 'rent_progress');
  const value = sourceValue([progress, ...visitSourceObjects(visit)], key);
  const number = numberValue(value);
  return number === null ? 0 : number;
};

const rentProgressSection = visit => {
  if (visitBusinessContext(visit) === 'for_sale') return null;

  const offers = rentProgressCount(visit, 'offers');
  const documentations = rentProgressCount(visit, 'documentations');
  const visits =
    rentProgressCount(visit, 'visits') ||
    (Array.isArray(visit?.imovel?.visitHistory)
      ? visit.imovel.visitHistory.length
      : 0);

  return {
    key: 'rent-progress',
    title: VISIT_DETAIL_SECTION_TITLES.RENT_PROGRESS,
    icon: 'i-lucide-chart-no-axes-column-increasing',
    metricRows: [
      {
        label: pluralProgressLabel(
          offers,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_OFFERS_ZERO,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_OFFER_ONE,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_OFFERS_MANY
        ),
        value: offers,
      },
      {
        label: pluralProgressLabel(
          documentations,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_DOCUMENTATION_ZERO,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_DOCUMENTATION_ONE,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_DOCUMENTATION_MANY
        ),
        value: documentations,
      },
      {
        label: pluralProgressLabel(
          visits,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_VISIT_ZERO,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_VISIT_ONE,
          VISIT_DETAIL_TEXT.RENT_PROGRESS_VISIT_MANY
        ),
        value: visits,
      },
    ],
  };
};

const briefingSection = visit => {
  const briefing = sectionObject(visit, 'briefing', 'briefingInfo');
  const href = firstPresent(
    briefing.url,
    sourceValue(visitSourceObjects(visit), 'briefingUrl')
  );
  const clientName = visit?.contact?.name || 'o cliente';

  return {
    key: 'briefing',
    title: VISIT_DETAIL_SECTION_TITLES.BRIEFING,
    icon: 'i-lucide-lightbulb',
    subtitle: VISIT_DETAIL_TEXT.BRIEFING_DESCRIPTION.replace(
      '{clientName}',
      clientName || 'o cliente'
    ),
    actions: [
      {
        key: 'briefing',
        label: VISIT_DETAIL_TEXT.BRIEFING_BUTTON,
        icon: 'i-lucide-external-link',
        href,
        disabled: !href,
      },
    ],
  };
};

const structuredAddress = visit => {
  const imovel = visit?.imovel || {};
  const attrs = imovelAttributes(visit);
  const address = sectionObject(visit, 'address', 'enderecoCompleto');
  return {
    street: firstPresent(
      address.street,
      address.logradouro,
      imovel.endereco,
      attrs.street,
      attrs.logradouro,
      imovel.titulo
    ),
    number: firstPresent(address.number, address.numero, imovel.numero),
    neighborhood: firstPresent(
      address.neighborhood,
      address.bairro,
      imovel.bairro
    ),
    city: firstPresent(address.city, address.cidade, imovel.cidade),
    state: firstPresent(address.state, address.uf, imovel.estado, attrs.uf),
  };
};

const wazeAddressLink = visit => {
  const query = visitAddressLine(visit);
  return query
    ? `https://waze.com/ul?q=${encodeURIComponent(query)}&navigate=yes`
    : '';
};

const directionsSection = visit => {
  const address = structuredAddress(visit);
  const google = googleMapsLink(address);
  const waze = wazeAddressLink(visit);

  if (!google && !waze) return null;

  return {
    key: 'directions',
    title: VISIT_DETAIL_SECTION_TITLES.DIRECTIONS,
    icon: 'i-lucide-map-pinned',
    subtitle: visitAddressLine(visit),
    actions: [
      {
        key: 'waze',
        label: VISIT_DETAIL_TEXT.WAZE,
        icon: 'i-lucide-navigation',
        href: waze,
      },
      {
        key: 'google-maps',
        label: VISIT_DETAIL_TEXT.GOOGLE_MAPS,
        icon: 'i-lucide-map',
        href: google,
      },
    ].filter(action => action.href),
  };
};

export const buildReferenceVisitSections = (
  visit,
  { companyName = 'Imudei', agentName } = {}
) =>
  [
    ciqSection(visit, { companyName, agentName }),
    ownerSection(visit),
    propertyResponsibleSection(visit, { companyName }),
    reservationSection(visit, { companyName }),
    rentProgressSection(visit),
    briefingSection(visit),
    directionsSection(visit),
  ].filter(Boolean);

export const visitTrackingPayload = (visit, extras = {}) => ({
  visit_id: visit?.id,
  visit_code:
    firstPresent(
      visit?.visitCode,
      visit?.visit_code,
      visitAttributes(visit).visitCode,
      visitAttributes(visit).visit_code
    ) || visit?.id,
  visit_status: visit?.status,
  business_context: visitBusinessContext(visit),
  house_id: visitImovelId(visit),
  contact_id: visitContactId(visit),
  scheduling_id:
    firstPresent(visit?.schedulingId, visit?.scheduling_id) || visit?.id,
  ...extras,
});

export const normalizedRecommendationItems = payload => {
  const items =
    payload?.items ||
    payload?.recommendations ||
    payload?.data?.items ||
    payload?.payload?.items ||
    [];
  return Array.isArray(items) ? items : [];
};

export const recommendationImovel = item =>
  item?.imovel || item?.house || item?.houseDetails || {};

export const recommendationHouseId = item =>
  item?.houseId || item?.house_id || recommendationImovel(item)?.id;

export const recommendationAddress = item => {
  const imovel = recommendationImovel(item);
  const address = imovel.address || {};
  return (
    [
      firstPresent(
        imovel.titulo,
        imovel.endereco,
        address.address,
        address.street
      ),
      imovel.bairro || imovel.neighbourhood || address.neighborhood,
      imovel.cidade || imovel.city || address.city,
    ]
      .filter(Boolean)
      .join(', ') || 'Imóvel recomendado'
  );
};

export const recommendationEntryAccessLabel = item => {
  const imovel = recommendationImovel(item);
  const entryAccess =
    imovel.entryAccess ||
    imovel.entry_access ||
    imovel.entryAccessDetails ||
    imovel.entry_access_details ||
    imovel.additionalAttributes?.entryAccess ||
    imovel.additionalAttributes?.entry_access ||
    imovel.additional_attributes?.entryAccess ||
    imovel.additional_attributes?.entry_access ||
    {};

  return (
    entryAccess.accessLabel ||
    entryAccess.access_label ||
    entryAccess.label ||
    entryAccessLabel(entryAccess.accessKey || entryAccess.access_key) ||
    VISIT_DETAIL_SECTION_TITLES.ENTRY
  );
};

export const recommendationDateTimeLabel = item => {
  const slot =
    item?.suggestedSlot || item?.suggested_slot || item?.visitTime || {};
  const startsAt = firstPresent(slot.startsAt, slot.starts_at, slot.dateTime);
  if (startsAt) {
    const label = formatDate(startsAt, {
      includeTime: true,
      weekday: 'short',
    });
    if (label) return label;
  }

  return [slot.date, slot.time || slot.timeId || slot.time_id]
    .filter(Boolean)
    .join(' às ');
};

export const recommendationVisitPayload = ({ visit, recommendation }) => {
  const slot =
    recommendation?.suggestedSlot ||
    recommendation?.suggested_slot ||
    recommendation?.visitTime ||
    {};
  const startsAt = firstPresent(slot.startsAt, slot.starts_at, slot.dateTime);
  const startsAtDate = startsAt ? new Date(startsAt) : null;

  return {
    contact_id: visitContactId(visit),
    imovel_id: recommendationHouseId(recommendation),
    user_id: visit?.user?.id || visit?.userId || visit?.user_id,
    conversation_id: visitConversationDisplayId(visit),
    scheduled_at:
      startsAtDate && !Number.isNaN(startsAtDate.getTime())
        ? startsAtDate.toISOString()
        : startsAt,
    status: 'agendada',
    buyer_visit_intention:
      visit?.buyerVisitIntention || visit?.buyer_visit_intention,
    additional_attributes: {
      source_visit_id: visit?.id,
      source: 'extra_visits_shortcut',
      origin: 'Corretores',
      on_behalf_of_role: 'DEMAND',
      recommendation_id:
        recommendation?.recommendationId || recommendation?.recommendation_id,
    },
  };
};
